<template>
  <div id="accordionSupplierNotificationLog" class="accordion">
    <div class="case-details accordion-item">
      <h2 id="headingNotificationLog" class="accordion-header">
        <button
          aria-controls="collapseNotificationLog"
          aria-expanded="true"
          class="accordion-button collapsed"
          data-bs-target="#collapseNotificationLog"
          data-bs-toggle="collapse"
          type="button"
        >
          <div class="mb-0 d-flex align-items-center">
            <div class="bg-primary rounded-xs me-8 d-flex align-items-center justify-content-center" style="width: 24px; height: 24px; flex: none;">
              <v-icon icon="description" size="xs" class="text-white" />
            </div>

            <div>
              <div class="h6 ff-secondary mb-0 fw-bold">{{ $t("clientTour.notificationLog") }}</div>
              <div class="fw-light accordion-subtitle text-xs" style="font-size: 10px !important;">{{ $t("clientTour.notificationLogSubtitle") }}</div>
            </div>
          </div>
        </button>
      </h2>

      <div
        id="collapseNotificationLog"
        aria-labelledby="headingNotificationLog"
        class="accordion-collapse collapse show"
        data-bs-parent="#accordionSupplierNotificationLog"
      >
        <div class="accordion-body pb-16 pb-xl-24">
          <div class="d-flex flex-column text-xs">
            <div class="table-notifications table-responsive d-none d-md-flex d-lg-none d-xl-block pe-8">
              <v-table class="mb-0">
                <v-table-header>
                  <tr class="text-normal">
                    <th class="text-xs">
                      {{ $t("general.shared.type") }}
                    </th>

                    <th class="text-xs">
                      Recipient
                    </th>

                    <th class="text-xs">
                      {{ $t("general.shared.date") }}
                    </th>
                  </tr>
                </v-table-header>

                <v-table-body class="fw-medium">
                  <template v-if="!!supplierNotificationLogs && supplierNotificationLogs.length > 0">
                    <tr v-for="notification in supplierNotificationLogs" :key="notification.id">
                      <td class="text-nowrap">
                        {{ formatEmailType(notification.email_type) }}

                        <span v-if="!!notification.supplier" class="text-muted">
                          ({{ notification.supplier.name }})
                        </span>

                        <span v-else class="text-muted">(-)</span>
                      </td>

                      <td class="text-nowrap text-muted">
                        {{ notification.email_to || '—' }}
                      </td>

                      <td class="text-nowrap">
                        {{ $str.formatDateTime(notification.created_at, settings.formatDatetime) }}
                      </td>
                    </tr>
                  </template>

                  <template v-else>
                    <tr>
                      <td class="rounded-xs py-16 text-center text-muted italic" colspan="2222">
                        {{ $t("clientTour.noSuppliersNotifications") }}
                      </td>
                    </tr>
                  </template>
                </v-table-body>
              </v-table>
            </div>

            <div class="item-cards d-block d-md-none d-lg-block d-xl-none">
              <template v-if="!!supplierNotificationLogs && supplierNotificationLogs.length > 0">
                <div
                  v-for="notification in supplierNotificationLogs"
                  :key="notification.id"
                  class="item-card border rounded-xs p-8 mb-8"
                >
                  <div>
                    <span class="fw-medium">{{ $t("general.shared.type") }}: </span>

                    <span>
                      {{ formatEmailType(notification.email_type) }}
                    </span>
                  </div>

                  <div>
                    <span class="fw-medium">{{ $t("general.shared.date") }}: </span>
                    <span>{{ $str.formatDateTime(notification.created_at, settings.formatDatetime) }}</span>
                  </div>
                </div>
              </template>

              <div v-else class="text-center text-muted italic">
                {{ $t("clientTour.noSuppliersNotifications") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VTable from "@/components/vendor/basic/table/VTable.vue";
import VTableHeader from "@/components/vendor/basic/table/VTableHeader.vue";
import VTableBody from "@/components/vendor/basic/table/VTableBody.vue";
import { findConceptByKey } from "@/helpers/ConceptHelper";
import { useAppStore } from "@/stores/app";

const props = defineProps<{
  agency: string;
  tour: number;
  clientTour: number;
  supplierNotificationLogs:{
    type: any[],
    required: true,
    default: []
  }
}>();

const appStore = useAppStore();
const settings = appStore.settings;

const formatEmailType = (emailType: string) => {
  if (!emailType) return '—';
  return emailType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
</script>

<style lang="scss" scoped>
.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
  padding: 0.5rem 1rem !important;
}

.table-notifications {
  overflow: auto;
  max-height: 23rem;

  thead th {
    background-color: var(--uq-body-bg);
  }
}

.table-notifications thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
